export const GET_CREATOR_TIERS = `query CreatorTiers {
    creatorTiers {
        edges {
            node {
                id
                name
                minSalesAmount
                maxSalesAmount
                minFollowers
                maxFollowers
            }
        }
    }
}`;
